import { useState, useEffect } from "react";
import { motion } from "framer-motion";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="site-navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 1.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-base-bg/85 backdrop-blur-md border-b border-emerald-900/15"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-serif text-2xl md:text-[1.7rem] tracking-tight text-emerald-900 leading-none"
        >
          TILT<span className="text-emerald-900/40"> Ventures</span>
        </button>
        <nav className="hidden md:flex items-center gap-10 text-[0.8rem] uppercase tracking-[0.18em] text-emerald-900/70">
          <button data-testid="nav-approach" onClick={() => scrollTo("approach")} className="hover:text-emerald-900 transition-colors">Approach</button>
          <button data-testid="nav-ireland" onClick={() => scrollTo("ireland")} className="hover:text-emerald-900 transition-colors">Ireland</button>
        </nav>
        <button
          data-testid="nav-contact-button"
          onClick={() => scrollTo("contact")}
          className="group relative overflow-hidden border border-emerald-900 px-6 py-2.5 text-[0.75rem] uppercase tracking-[0.18em] text-emerald-900"
        >
          <span className="relative z-10 transition-colors duration-300 group-hover:text-base-bg">Get in Touch</span>
          <span className="absolute inset-0 z-0 bg-emerald-900 translate-y-full transition-transform duration-300 group-hover:translate-y-0" />
        </button>
      </div>
    </motion.header>
  );
}
